import { useQuery } from '@tanstack/react-query';
import { resourceDetailsQueryKeys } from './resourceDetailsQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';

const useQueryNotepadResourceSync = (resource, getCurrentState, queryOptions) => {
  const { client } = useWoody();
  const accessToken = useContextAccessToken();
  const query = useQuery({
    queryKey: resourceDetailsQueryKeys.notepadSync(resource),
    queryFn: async (params) => {
      const safeResourceId = params.queryKey[1];
      const currentState = getCurrentState?.();
      const response = await client.v2({
        endpoint: "/v2/notepads/{resourceId}/sync",
        params: {
          resourceId: safeResourceId
        }
      }, {
        query: {
          accessToken
        },
        method: "post",
        body: currentState ? new Blob([
          currentState
        ], {
          type: "application/content-stream"
        }) : new Blob()
      });
      return new Uint8Array(await response.arrayBuffer());
    },
    staleTime: 1e4,
    refetchInterval: 9e3,
    persister: void 0,
    gcTime: 0,
    placeholderData: void 0,
    initialData: void 0,
    ...queryOptions,
    enabled: isQueryEnabled([
      !!resource?.id,
      !!getCurrentState,
      queryOptions?.enabled
    ])
  });
  return {
    ...query
  };
};

export { useQueryNotepadResourceSync };
//# sourceMappingURL=useQueryNotepadResourceSync.js.map
